export default {
    mark_as_rma_title: "Mark as RMA",
    mark_as_rma_input: "IMEI or Serial",
    mark_as_rma_imei: "IMEI",
    mark_as_rma_serial: "Serial",
    mark_as_rma_model: "Model",
    mark_as_rma_change: "Mark as RMA",
    mark_as_rma_no_devices_added: "No devices added",
    mark_as_rma_device_is_already_added: "The device is already added",
    mark_as_rma_device_has_not_been_found: "The device has not been found",
    mark_as_rma_this_feature_is_not_available: "This feature is not available",
    mark_as_rma_single_success_message: "The device has been marked as RMA",
    mark_as_rma_multiple_success_message: "The the devices has been marked as RMA",
    mark_as_rma_error_message: "Unable to mark as RMA due to an error",
    mark_as_rma_show_in_web: "Show In Web",
    mark_as_rma_number: "RMA Number",
    mark_as_rma_device_is_already_rma: "The device is already marked as RMA",
    mark_as_rma_device_is_already_refirbished: "The device is already refurbished",
    mark_as_rma_devices_is_already_rma: "There are devices already marked as RMA",
    mark_as_rma_devices_is_already_refirbished: "There are devices already refurbished",
    mark_as_rma_min_message: "RMA number must be at least 5 digits long",
    mark_as_rma_transaction_message: "The request to mark the devices as RMA has been sent successfully, please check the transactions list to see the status of the request.",
}

